import {FunctionComponent} from 'react';

export type ModalContentProps = { className?: string }

const ModalContent: FunctionComponent<ModalContentProps> = (props) => {
    return (
        <div className={`dfb-Modal-modalContent ${props.className ?? ''}`}>
            {props.children}
        </div>
    );
};

export default ModalContent;
